import { getUrl, sessionExpired } from "../setEnvironment";

class WarningsAPI {
  constructor() {
    this.URL = getUrl();
    this.getWarnings=this.getWarnings.bind(this)
  }

  // P01021-137: el backend nunca llegó a usar username para nada.
  async getWarnings(token) {
    try {
      const response = await fetch(this.URL+"/warnings/getWarnings", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": token
        },
      }).catch(function (e) {
        console.log(e)
        throw e;
      });
      if (sessionExpired(response.status)) return;
      const json = await response.json();
      return json
    } catch (e) {
      throw e;
    }
  }
}

let _warningsAPI = null;

const initWarningsAPI = () => {
  if (!_warningsAPI) {
    _warningsAPI = new WarningsAPI();
  }
  return _warningsAPI;
};

const getWarningsAPI = () => {
  return initWarningsAPI();
};

export { initWarningsAPI, getWarningsAPI };
